import React, { Component } from "react";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  Button,
  Center,
  Box,
  Text,
  IconButton,
  Flex,
  Spacer,
  Image,
  Wrap,
  WrapItem,
  Stack,
  Icon,
  HStack,
} from "@chakra-ui/react";
import * as objs from "../../objs";

class Cron extends Component {
  state = { TruckPendingReports: [] };

  componentDidMount() {
    this.addMoreListeners();
  }

  async addMoreListeners() {
    this.props.chatSocket.on("cron", (data) => {
      var j = JSON.parse(data);
      //console.log(j["data"]);
      if (j["type"] == "TruckPendingReports") {
        this.setState({ TruckPendingReports: j["data"] });
      }
    });
  }

  showData() {
    const { TruckPendingReports } = this.state;
    if (TruckPendingReports.length > 0) {
      var objMagicTbl = new objs.objMagicTable(
        TruckPendingReports,
        [],
        [
          "vehicle_location",
          "rego_full",
          "request_date",
          "request_response_date",
          "resource_full_name",
          "priority",
          "request_by",
          "request_summary",
          "request_details",
        ]
      );
      return (
        <Box maxW="100%" overflow="auto">
          {objMagicTbl.getStrictTable("chakra")}
        </Box>
      );
    } else {
      return <></>;
    }
  }

  render() {
    return (
      <Center>
        <Stack w="100%">
          <Wrap>
            <WrapItem>
              <Button
                colorScheme="teal"
                h="50px"
                onClick={() =>
                  this.props.chatSocket.emit("flexSend", "TruckPendingReports")
                }
              >
                <Box>
                  <Center>Pending Repair/Service</Center>
                </Box>
              </Button>
            </WrapItem>
          </Wrap>
          <Box w="100%" h="100%">
            {this.showData()}
          </Box>
        </Stack>
      </Center>
    );
  }
}

export default Cron;
